/**
 * Settings hub (/settings) — the single Menu entry that fans out to the
 * individual settings pages. Row copy lives here so the hub and any future
 * surface that names these destinations stay in agreement.
 */
export const settingsCopy = {
  pageTitle: 'Settings',
  rows: {
    notifications: { title: 'Notifications', description: 'Manage your notification preferences' },
    appearance: { title: 'Appearance', description: 'Light, Dark, or match your system' },
    blockedMembers: { title: 'Blocked Members', description: 'Manage blocked accounts' },
    reports: { title: 'Reports', description: 'View your submitted reports' },
    subscription: { title: 'Subscription', description: 'Manage your Paire plan' },
  },
  newBadge: 'New',
} as const;
